
import type { PropType } from 'vue'
import type { KpiEnum } from '../enums'
import { useDark } from '@vueuse/core'
import { defineComponent } from 'vue'
import { ColorEnum } from '../enums'

import { EpbText } from './shared/epb-text'

interface KpisLegendItem {
  id: string
  label: string
}

export default defineComponent({
  name: 'KpisLegend',
  components: {
    EpbText,
  },
  props: {
    value: {
      type: Array as PropType<Array<KpiEnum>>,
      default: () => [],
    },
    items: {
      type: Array as PropType<Array<KpisLegendItem>>,
      default: () => [],
    },
    multiSelect: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const isDark = useDark({
      selector: 'html',
      attribute: 'data-theme',
      valueDark: 'dark',
      valueLight: '',
    })

    return {
      isDark,
    }
  },
  data() {
    return {
      baseClass: 'epb-opportunity-performance-legend',
    }
  },
  methods: {
    getTextColor(kpiId: KpiEnum): string {
      const isSelected = this.value.includes(kpiId)

      if (this.isDark) {
        return isSelected ? ColorEnum.NEUTRAL_75 : ColorEnum.BLACK
      } else {
        return isSelected ? ColorEnum.BLACK : ColorEnum.NEUTRAL_75
      }
    },
    onKpiChange(kpiEnum: KpiEnum): void {
      let selectedOptions = this.value
      const indexOf = selectedOptions.indexOf(kpiEnum)

      if (indexOf !== -1) {
        if (selectedOptions.length === 1) {
          return
        }
        selectedOptions.splice(indexOf, 1)
      } else {
        if (this.multiSelect) {
          selectedOptions.push(kpiEnum)
        } else {
          selectedOptions = [kpiEnum]
        }
      }
      this.$emit('input', selectedOptions)
    },
  },
})
